// custom typefaces
// import "@fontsource/montserrat/variable.css"
// import "@fontsource/merriweather"
// normalize CSS across browsers
// import "./src/normalize.css"
// custom CSS styles
// import "./src/style.css"

// Highlighting for code blocks
// import "prismjs/themes/prism.css"
import "@code-hike/mdx/styles.css"
import "./custom.css"

import { ColorSchemeProvider, MantineProvider } from "@mantine/core"
import * as React from "react"
import { useToggle } from "@mantine/hooks"
// import { Layout } from "./src/components/layout"

function Provider({ children }) {
  const [dark, toggle] = useToggle([true, false])
  return (
    <ColorSchemeProvider
      colorScheme={dark ? "dark" : "light"}
      toggleColorScheme={() => {
        toggle()
      }}
    >
      <MantineProvider
        withCSSVariables={true}
        withNormalizeCSS={true}
        withGlobalStyles={true}
        theme={{
          colorScheme: dark ? "dark" : "light",
          components: {
            Badge: {
              defaultProps: theme => ({
                color: theme.colorScheme === "dark" ? "pink.7" : "blue.6",
              }),
            },
            Alert: {
              defaultProps: theme => ({
                variant: theme.colorScheme === "dark" ? "light" : "filled",
              }),
            },
          },
          globalStyles: theme => ({
            badge: {
              color:
                theme.colorScheme === "dark"
                  ? theme.colors.gray[3]
                  : theme.colors.dark[7],
            },
            blockquote: {
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[6]
                  : theme.colors.gray[0],
              borderLeft: `4px solid ${
                theme.colors[theme.primaryColor][
                  theme.colorScheme === "dark" ? 4 : 6
                ]
              }`,
              margin: 0,
              padding: 4,
              paddingLeft: 16,
            },
            code: {
              padding: 2,
              paddingLeft: 8,
              paddingRight: 8,
              borderRadius: 8,
              // fontWeight: 200,
              color:
                theme.colorScheme === "dark"
                  ? theme.colors.teal[5]
                  : theme.colors.dark[7],
              fontFamily: theme.fontFamilyMonospace,
              // fontStyle: "Fira Code",
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[6]
                  : theme.colors.blue[1],
            },
            body: {
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[4]
                  : theme.colors.gray[3],
            },
          }),
        }}
      >
        {children}
      </MantineProvider>
    </ColorSchemeProvider>
  )
}

export const wrapRootElement = ({ element }) => {
  return <Provider>{element}</Provider>
}

// export const onServiceWorkerUpdateReady = () => window.location.reload(true)
// export const onServiceWorkerUpdatedFound = () => window.location.reload(true)
